import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "vns_session_token";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach the session token as a Bearer header so auth works even when the
// browser blocks the cross-site session cookie (e.g. Chrome third-party cookies).
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (e) { /* ignore */ }
  return config;
});

// On a 401 for a previously-authenticated user, show a friendly notice and
// redirect to login instead of a silent bounce. Skips the initial /auth/me
// probe (no token) and avoids duplicate toasts.
let sessionExpiredHandled = false;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    let hasToken = false;
    try { hasToken = !!localStorage.getItem(TOKEN_KEY); } catch (e) { /* ignore */ }
    const onLogin = window.location.pathname === "/login";
    if (status === 401 && hasToken && !onLogin && !sessionExpiredHandled) {
      sessionExpiredHandled = true;
      try { localStorage.removeItem(TOKEN_KEY); } catch (e) { /* ignore */ }
      toast.error("Your session has expired. Please sign in again.", { duration: 4000 });
      setTimeout(() => { window.location.href = "/login"; }, 1500);
    }
    return Promise.reject(error);
  }
);

export default api;
